import { AxiosError, AxiosResponse } from 'axios'

import { APIError, AuthError, BadRequestError, HttpError, ValidationError } from '@percent/education-hosted-form/errors'

export const responseSuccessInterceptor = (response: AxiosResponse) => response

export const responseFailureInterceptor = async (
  error: AxiosError<{ error: { reasons?: string[]; message?: string; code?: string } }>
) => {
  try {
    const errorMsg = error?.response?.data?.error?.message || error?.message
    const errorCode = error?.response?.data?.error?.code

    switch (error.response?.status) {
      case 500:
        throw new APIError({ message: errorMsg, cause: error, code: errorCode })

      case 401:
        throw new AuthError({ message: errorMsg, cause: error, code: errorCode })

      case 400:
        throw error.response?.data?.error?.reasons
          ? new ValidationError({ message: errorMsg, cause: error, code: errorCode })
          : new BadRequestError({ message: errorMsg, cause: error, code: errorCode })

      default:
        throw new HttpError({ message: errorMsg, cause: error, code: errorCode })
    }
  } catch (err) {
    return Promise.reject(err)
  }
}
